export const PAGE_TEXT: {
  information: Record<string, string>;
  question: string[];
  level: Record<string, string>;
  labels: Array<{ value: string; label: string; abbr: string }>;
  notesToReferees: string[];
  refereeFormHeader: any;
  refereeAction: any;
  refereeStatus: Record<string, string>;
  formStatus: Record<string, string>;
} = {
  information: {
    nameOfApplicant: 'Name of Applicant',
    department: 'Choice of Department',
    programme: 'Choice of Programme',
    researchArea: 'Choice of Research Field',
    nameOfReferee: 'Name of Referee',
    institution: 'Institution',
    position: 'Position',
    email: 'Email',
    telephoneNumber: 'Telephone Number',
    faxNumber: 'Fax Number',
    address: 'Address',
    headerNote:
      "Your referee will receive the link to complete the referee's report only after you have completed the payment.",
    addReferee: 'Add New Academic Referee',
    maxReferee: '* Max 5 Academic Referees are allowed',
    changeEmail: 'Change Email Address',
    newEmail: 'New Email Address',
    resendEmail: 'Resend Email',
    resendEmailConfirm: 'Are you sure you want to resend the email?',
  },
  question: [
    '1. How long and in what capacity have you known the applicant?',
    '2. How would you rate the following characteristics of the applicant in comparison with other students you have taught or supervised? (Please tick as appropriate)',
    '3. How many students are there in your comparison group?',
    '4. Please describe the research ability and potential of the applicant, and explain any other dimensions of the applicant’s experience and skills that are relevant to his/her application?',
    '5. What is your overall recommendation for the applicant to pursue research studies in Hong Kong?',
  ],
  level: {
    EXCELLENT: 'Excellent (top 5%)',
    VERY_GOOD: 'Good (top 6% - 20%)',
    SATISFACTORY: 'Satisfactory (top 21% - 50%)',
    AVERAGE_OR_BELOW: 'Average or below (lower than 50%)',
    NO_BASIS_FOR_JUDGMENT: 'No basis for judgment',
  },
  labels: [
    {
      value: '0',
      label: 'Intellectual capacity',
      abbr: 'intellectualCapacity',
    },
    {
      value: '1',
      label: 'Analytical power and reasoning',
      abbr: 'analyticalPower',
    },
    {
      value: '2',
      label: 'Knowledge of proposed research study',
      abbr: 'knowledgeOfStudy',
    },
    { value: '3', label: 'Judgment', abbr: 'judgment' },
    { value: '4', label: 'Imagination and originality', abbr: 'imagination' },
    { value: '5', label: 'Motivation and perseverance', abbr: 'motivation' },
    {
      value: '6',
      label: 'Skills of writing and argumentation',
      abbr: 'skillsOfWriting',
    },
    {
      value: '7',
      label: 'Ability for conducting scholastic research',
      abbr: 'conductingAbility',
    },
    {
      value: '8',
      label: 'Capacity for independent work',
      abbr: 'independentWork',
    },
    {
      value: '9',
      label: 'Reliability and sense of responsibility',
      abbr: 'reliability',
    },
  ],
  notesToReferees: [
    'The applicant named below is applying for the admission to the research degree programme offered by the Hong Kong Polytechnic University. Please complete this report in English and submit the completed report directly through this page.',
    // 'Please refrain from mentioning the name of the nominating university to enable blind review to be conducted.',
    'All information given here will be treated as strictly confidential. It will be accessible only to the Selection Panels of the Hong Kong Polytechnic University.',
    'Please provide concrete and sufficient information in the report to facilitate the Selection Panel in evaluating the candidate’s research ability and potential.',
    'All information submitted shall be handled in accordance with the requirements stipulated by the Personal Data (Privacy) Ordinance in Hong Kong.',
  ],
  refereeFormHeader: {
    NAME: 'Name',
    EMAIL: 'Email',
    STATUS: 'Status',
    ACTION: 'Action',
    LAST_SENT_TIME: 'Last Sent Time',
    REPLY_TIME: 'Reply Time',
    DEADLINE: 'Deadline',
  },
  refereeAction: {
    RESEND: 'Resend',
    CHANGE_EMAIL: 'Change Email',
    CHANGE: 'Change',
    SAVE_REFEREE: 'Save & Send Email',
    CANCEL: 'Cancel',
  },
  refereeStatus: {
    CREATED: 'Pending',
    SUBMITTED: 'Received',
    EXPIRED: 'Overdue',
  },
  formStatus: {
    ACTION_REQUIRED: 'Action Required',
    NO_ACTION_REQUIRED: 'No Action Required',
    ACTION_REQUIRED_DESCRIPTION:
      'Your referees are yet to respond to your request. Please remind them to complete the form.',
    NO_ACTION_REQUIRED_DESCRIPTION:
      'Your referees have completed the form. Thank you for your submission.',
  },
};
